export const SCAN_STATS_ENGAGEMENT = (scanWaveId?: string) =>
  `/api/v1/scan-stats/engagement${scanWaveId ? `?scanWaveId=${scanWaveId}` : ''}`;
